// extracted by mini-css-extract-plugin
module.exports = {"bodyfloater":"App_bodyfloater__tQp96","body":"App_body__10BWi"};